import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  CustomerOpportunitiesInfo,
  DeactivateOpportunityRequest,
  OpportunityInfo,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root'
})
export class OpportunityService {
  private readonly sdk = inject(ApiClient);

  getOpportunity(id: string): Observable<OpportunityInfo> {
    return this.sdk.getOpportunity(id);
  }

  getCustomerOpportunities(customerId: number): Observable<CustomerOpportunitiesInfo> {
    return this.sdk.getCustomerOpportunities(customerId);
  }

  deactivateOpportunity(id: string, request: DeactivateOpportunityRequest): Observable<OpportunityInfo> {
    return this.sdk.deactivateOpportunity(id, request);
  }
}
